import React, { Component } from 'react';
import SpotlightTrack from 'components/user/SpotlightTrack.js';
import { connect } from "react-redux";
import {setIsPlaying} from "actions/index.js";

// responsible for showing tracks
class TracksComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            draggingSpotlightTrack: undefined
        };
              
    }

    play(sequence) {
        this.props.multiSequencerEngine.play(sequence);
    }

    unloadTrack(sequenceId) {
        this.props.unloadTrack(sequenceId);
    }
    
    loadTrack(id) {
        this.props.loadTrack(id);
    }

    getSequencerEngine(id) {
        return this.props.multiSequencerEngine.getSequencerEngine(id);
    }

    setDraggingSpotlightTrack(track) {
        this.setState({
            draggingSpotlightTrack: track
        });
    }

    render() {
        return (
            <div className="user-tracks">
              {this.props.tracks.map(
                  (sequence, i) => 
                      <SpotlightTrack
                            isPlayable={this.props.isPlayable}
                            play={() => this.play(sequence)}
                            i={i}
                            viewMode={this.props.viewMode}
                            tracks={this.props.tracks}
                            isEditing={this.props.isEditing}
                            ethereum={this.props.ethereum}
                            setDraggingSpotlightTrack={(track) => this.setDraggingSpotlightTrack(track)}
                            draggingSpotlightTrack={this.state.draggingSpotlightTrack}
                            isPlaying={this.props.isPlaying[sequence.id]}
                            unloadTrack={() => this.unloadTrack(sequence.id)}
                            loadTrack={() => this.loadTrack(sequence.id)}
                            key={'sequence-' + sequence.id}
                            onEditSequence={this.props.onEditSequence}
                            sequencerEngine={this.getSequencerEngine(sequence.id)}
                            userId={this.props.userId}
                            onClickDelete={() => this.props.onDeleteTrack(sequence)}
                            loadingSequence={this.props.loadingSequence}
                            store={this.props.store}
                            sequence={sequence}/>)}
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        isPlaying: state.sequencer.isPlaying,
        loadingSequence: state.sequencer.loadingSequence,
        loadedTracks: state.user.loadedTracks,
        viewMode: state.user.viewMode,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setIsPlaying: (id, x) => dispatch(setIsPlaying(id, x)),
    };
};

 
export default connect(mapStateToProps, mapDispatchToProps)(TracksComponent);
